import React from "react";
import { Typography } from "../../../../../../components";
import { OrderData, getStatusLabel } from "./utils";
import { useTranslations } from "../../../../../../contexts/translation.context";

interface StatusCellProps {
  order: OrderData;
}

const StatusCell: React.FC<StatusCellProps> = ({ order }) => {
  const { t } = useTranslations();

  return (
    <div className="flex items-center">
      <div className="flex items-center gap-[4px] bg-gray-100 text-gray-900 h-[24px] px-[8px] py-[4px] rounded-lg whitespace-nowrap">
        <div className={`w-2 h-2 rounded-full ${
          order.status === 'in_progress' ? 'bg-blue-600' :
          order.status === 'pending' ? 'bg-yellow-600' :
          order.status === 'completed' ? 'bg-green-600' :
          order.status === 'not_started' ? 'bg-[#71717A]' :
          order.status === 'canceled' ? 'bg-[#F31260]' :
          'bg-gray-600'
        }`}></div>
        <Typography variant="body3" className="text-gray-900">
          {getStatusLabel(order.status, t)}
        </Typography>
      </div>
    </div>
  );
};

export default StatusCell;
